import * as yup from "yup";

import { Shape } from "@/core/yup";
import { fakeI18n } from "@/i18n";

import { CompanyFormType } from "../../formType";

export const formSchemaPhone = yup.object<{}, Shape<MyBrokerApi.TelephoneNumberForm>>({
    number: yup.string().phone().required(),
    type: yup.string().required(),
    description: yup.string(),
});

export const formSchemaEmail = yup.object<{}, Shape<MyBrokerApi.EmailAddressForm>>({
    email: yup.string().email().required(),
    description: yup.string(),
});

export const formSchemaContact = yup.object<{}, Shape<CompanyFormType>>({
    contact: yup.object<{}, Shape<MyBrokerApi.MoralContactForm>>({
        telephoneNumbers: yup.array(formSchemaPhone).unique("number", fakeI18n.t("Common.Phone")),
        emailAddresses: yup.array(formSchemaEmail).unique("email", fakeI18n.t("Common.Email")),
    }),
});
